<template>
  <router-view />
</template>

<script setup lang="ts">
// Simple wrapper that renders nested route content - used to avoid nested layouts
</script>
